document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('scroll', () => {
        const sc = window.scrollY;
        const header = document.querySelector('header');

        if (sc > 150) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });

    const topButton = document.querySelector('.top-button');
    if (topButton) {
        document.addEventListener('scroll', () => {
            const y = window.scrollY;

            if (y > 640) {
                topButton.classList.add('visible');
            } else {
                topButton.classList.remove('visible');
            }
        });
    }

    // NAVIGATION MOBILE
    const body = document.querySelector('body');
    const header = document.querySelector('header');
    const toggle = header?.querySelector('.menu-toggle');
    const hiddenText = toggle.querySelector('.visually-hidden');
    const nav = header?.querySelector('#site-navigation');

    if (!toggle || !nav) return;

    function openMenu() {
        nav.classList.add('is-open');
        body.classList.add('no-scroll');
        toggle.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
        nav.classList.remove('is-open');
        body.classList.remove('no-scroll');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
    }

    toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        expanded ? closeMenu() : openMenu();
        hiddenText.textContent = expanded ? 'Ouvrir le menu' : 'Fermer le menu';
    });

    document.addEventListener('click', (e) => {
        if (
            nav.classList.contains('is-open') &&
            !nav.contains(e.target) &&
            !toggle.contains(e.target)
        ) {
            closeMenu();
        }
    });

    // Slider
    const slider = document.querySelector('#hero-slider');
    if(slider) {
        new Splide('#hero-slider', {
            type       : 'loop',
            autoplay   : true,
            interval   : 10000,
            speed      : 1000,
            arrows     : false,
            pagination : true,
            pauseOnHover: false,
            pauseOnFocus: false,
        }).mount();
    }

    // GSAP
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".hero .hero__content > *", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.2
    });

    const tlThemes = gsap.timeline({
        scrollTrigger: {
        trigger: "#programme",
        start: "top 85%", // quand la liste arrive à 85% du viewport
        toggleActions: "play none none none",
        //markers: true
        }
    });

    // Apparition des items engagements
    tlThemes.to(".themes__item", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.2
    });

    // Apparition du bloc emphase à la fin
    tlThemes.to(".anim", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out"
    }, "+=0.2");

    const quotes = document.querySelectorAll("p.quote");

    if(quotes) {
        const isMobile = window.innerWidth <= 768;
        if (!isMobile) return;

        quotes.forEach((quote) => {
        const fullText = quote.textContent.trim();
        const words = fullText.split(" ");

        if (words.length <= 15) return;

        const truncated = words.slice(0, 15).join(" ") + "...";

        quote.textContent = truncated;

        const button = document.createElement("button");
        button.textContent = "Lire la suite";
        button.classList.add("read-more-btn");

        quote.appendChild(document.createTextNode(" "));
        quote.appendChild(button);

        button.addEventListener("click", function () {
        quote.textContent = fullText;
        });
    });
    }
});